export default defineNuxtRouteMiddleware(to => {
    if (to.name?.toString().includes("ke-stazeni___")) {
        const localePath = useLocalePath()
        return navigateTo(localePath("ke-stazeni-2024"))
    }
})
